<div class="dashboard-content-sec">

    <div class="row mb-3">
        <div class="col-md-4" *ngIf="userSer.haveAccess( 'client' )">
            <div class="card hide-overflow">
                <div class="card-body">
                <h5 class="card-title">Client Setup</h5>
                <!-- <p class="card-text">Create, Edit, and Delete Clients</p> -->
                <a href="javascript:void(0)" [routerLink]="['/admins/client-list']" routerLinkActive="active"
                    class="btn btn-default">Configuration
                </a>          
                </div>
            </div>
        </div>

        <div class="col-md-4" *ngIf="userSer.haveAccess( 'client-profile' )">
            <div class="card hide-overflow">
                <div class="card-body">
                <h5 class="card-title">Client Profile</h5>
                <!-- <p class="card-text">Create, Edit, and Delete Clients</p> -->
                <a href="javascript:void(0)" [routerLink]="['/admins/client']" routerLinkActive="active"
                    class="btn btn-default">Configuration
                </a>          
                </div>
            </div>
        </div>

        <div class="col-md-4" *ngIf="userSer.haveAccess('partner')">
            <div class="card hide-overflow" >
                <div class="card-body">
                <h5 class="card-title">Partner Setup</h5>
                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
                <a href="javascript:void(0)" [routerLink]="['/admins/partner-list']" routerLinkActive="active"
                    class="btn btn-default">Configuration</a>
                </div>
            </div>
        </div>


        <div class="col-md-4" *ngIf="userSer.haveAccess('partner-profile')">
            <div class="card hide-overflow" >
                <div class="card-body">
                <h5 class="card-title">Partner Profile</h5>
                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
                <a href="javascript:void(0)" [routerLink]="['/admins/partner']" routerLinkActive="active"
                    class="btn btn-default">Configuration</a>
                </div>
            </div>
        </div>
    
        <div class="col-md-4"  *ngIf="userSer.haveAccess('user')">
            <div class="card hide-overflow">
                <div class="card-body">
                <h5 class="card-title">User Setup</h5>
                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
                <a href="javascript:void(0)" [routerLink]="['/admins/user-list']" routerLinkActive="active"
                    class="btn btn-default">Configuration</a>
                </div>
            </div>
        </div>

        <div class="col-md-4"  *ngIf="userSer.haveAccess('user-profile')">
            <div class="card hide-overflow">
                <div class="card-body">
                <h5 class="card-title">Your Profile</h5>
                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
                <a href="javascript:void(0)" [routerLink]="['/admins/user/', { personal : true }]" routerLinkActive="active"
                    class="btn btn-default">Configuration</a>
                </div>
            </div>
        </div>

    </div>


    <div class="row">
        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.haveAccess('hr-setup')">
                <div class="card-body">
                <h5 class="card-title">HR Solution Center</h5>
                <p class="card-text">Overview, Documents, Checklists</p>
                <a href="javascript:void(0)" [routerLink]="['/admins/page-list/HR']" routerLinkActive="active"
                    class="btn btn-default">HR Pages Setup
                </a>          
                </div>
            </div>
        </div>   

        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.haveAccess('business-setup')">
                <div class="card-body">
                <h5 class="card-title">Business Center</h5>
                <p class="card-text">Overview, Documents, Checklists</p>
                <a href="javascript:void(0)" [routerLink]="['/admins/page-list/PRO']" routerLinkActive="active"
                    class="btn btn-default">PRO Pages Setup
                </a>          
                </div>
            </div>
        </div>   


        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.haveAccess('erisa-setup')">
                <div class="card-body">
                <h5 class="card-title">ERISA Center</h5>
                <p class="card-text">Overview, Documents, Checklists</p>
                <a href="javascript:void(0)" [routerLink]="['/admins/page-list/ERISA']" routerLinkActive="active"
                    class="btn btn-default">ERISA Pages Setup
                </a>          
                </div>
            </div>
        </div>   

    </div>


    <div class="row">
        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.haveAccess('roleprofile')">
                <div class="card-body">
                <h5 class="card-title">Role Profiles</h5>
                <p class="card-text">Roles and Authorizations</p>
                <a href="javascript:void(0)" [routerLink]="['/admins/roleprofile-list']" routerLinkActive="active"
                    class="btn btn-default">Role Profile Setup
                </a>          
                </div>
            </div>
        </div>   


        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.haveAccess('states')">
                <div class="card-body">
                <h5 class="card-title">State Updates</h5>
                <p class="card-text">State Update Laws and Changes</p>
                <a href="javascript:void(0)" [routerLink]="['/admins/states-list']" routerLinkActive="active"
                    class="btn btn-default">State Update Setup
                </a>          
                </div>
            </div>
        </div>   

        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.haveAccess('content')">
                <div class="card-body">
                <h5 class="card-title">Newsletter/Blogs/etc</h5>
                <p class="card-text">Content for dashboard</p>
                <a href="javascript:void(0)" [routerLink]="['/admins/content-list']" routerLinkActive="active"
                    class="btn btn-default">Newsletters/Blogs/etc Setup
                </a>          
                </div>
            </div>
        </div>   

    </div>

    <div class="row">
        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.haveAccess('document')">
                <div class="card-body">
                <h5 class="card-title">Document Library</h5>
                <p class="card-text"></p>
                <a href="javascript:void(0)" [routerLink]="['/admins/document-list']" routerLinkActive="active"
                    class="btn btn-default">Document Setup
                </a>          
                </div>
            </div>
        </div>   

        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.haveAccess('email-templates')">
                <div class="card-body">
                <h5 class="card-title">Email Templates</h5>
                <p class="card-text"></p>
                <a href="javascript:void(0)" [routerLink]="['/admins/template-list']" routerLinkActive="active"
                    class="btn btn-default">Configure
                </a>          
                </div>
            </div>
        </div>   

        <div class="col-md-4">
            <div class="card hide-overflow" *ngIf="userSer.isAdmin()">
                <div class="card-body">
                <h5 class="card-title">Ticket Reassignment</h5>
                <p class="card-text">Move tickets from one account to another attorney</p>
                <a href="javascript:void(0)" [routerLink]="['/admins/bulk-reassign']" routerLinkActive="active"
                    class="btn btn-default">Reassign Tickets
                </a>
                </div>
            </div>
        </div>

    </div>


</div>